import { MemberProps } from 'app/components/Core/convention'
import KLocationButton from 'app/components/Modules/Map/KLocationButton'
import GoogleMap from 'app/components/Modules/Map/Map'
import { GenericObject } from 'app/constants/GlobalTypes'
import { attributeNames } from 'app/lib/utils/delivery-address'
import React from 'react'

import useDeliveryAddressForm from '../Rental/hooks/useDeliveryAddressForm'

type Props = {
  height?: string
}

const CheckoutMap: React.FC<MemberProps<IRental, Props>> = ({
  member,
  props: { height = '250px' }
}) => {
  const { open } = useDeliveryAddressForm(member?.id?.toString())
  const onSuccess = (address: GenericObject<string>) => {
    const member: IDeliveryAddress = {
      addressSummary: `${address.deliveryAddress1}, ${address.deliveryCity}`,
      ...address
    }
    open({ member })
  }

  return (
    <GoogleMap
      collection={
        member ? [{ id: member.id, longitude: member.longitude, latitude: member.latitude }] : []
      }
      options={{
        streetViewControl: false,
        mapTypeControl: false,
        zoomControl: false,
        fullscreenControl: false
      }}
      button={<KLocationButton onSuccess={onSuccess} names={attributeNames} />}
      height={height}
    />
  )
}

export default CheckoutMap
